import { useLang } from "@/lib/lang";

export default function HowItWorks() {
  const { t } = useLang();
  return (
    <section id="how" className="py-20 md:py-28 relative overflow-hidden" style={{ background: "var(--primary)", color: "var(--text-inverse)" }}>
      <div className="grain absolute inset-0" />
      <div className="relative max-w-7xl mx-auto px-5 md:px-8">
        <div className="max-w-3xl">
          <div className="section-eyebrow" style={{ color: "var(--mustard)" }}>Process</div>
          <h2 className="mt-3 font-display text-4xl md:text-5xl">{t.how.title}</h2>
        </div>
        <ol className="mt-14 grid md:grid-cols-5 gap-6">
          {t.how.steps.map((s, i) => (
            <li key={i} data-testid={`step-${i + 1}`} className="relative">
              <div className="font-display text-7xl leading-none opacity-30" style={{ color: "var(--mustard)" }}>0{i + 1}</div>
              <div className="mt-3 text-lg font-semibold leading-snug">{s}</div>
              {i < t.how.steps.length - 1 && (
                <div className="hidden md:block absolute top-8 left-full w-full h-px opacity-20" style={{ background: "var(--mustard)" }} />
              )}
            </li>
          ))}
        </ol>
        <blockquote className="mt-16 max-w-3xl font-display text-2xl md:text-3xl leading-snug border-l-4 pl-6" style={{ borderColor: "var(--mustard)" }}>
          &ldquo;No confusion. No overthinking. You focus on work — we handle the food part.&rdquo;
        </blockquote>
      </div>
    </section>
  );
}
